import { MouseEvent, createRef, useEffect, useImperativeHandle, useState } from "react"
import { ActionPlanState, CloseReincidence, CloseSignature, DefaultReportFolio, OptionActionsBodyProps, ReincidenceState, SignatureState } from "./types"
import { Grid, Typography } from "@mui/material"
import { DinamicFormRefModel, DynamicFormRefValues, DynamicRefRef } from "../../../../components/dynamicFormRef/types"
import { ClickedBox } from "../clickedBox"
import { ArrowBackActionPlan } from "../actionPlanDrawer"
import { useEvidencesType } from "../../../../hooks/evidences/useEvidences"
import { EvidenceData } from "../../../../hooks/evidences/typyng"
import { getActionPlans } from "../../pages/detail/methods"
import { useTranslation } from "react-i18next"
import { ErrorMessage } from "../../../../components"
import { ArrowBackPayload } from "../../pages/detail/fragments/reportFolioByAnswer/typee"
import { useRefs } from "../../../../hooks/useReactHookModified"
import { validateReportFolio } from "./methods"
import { useNavigate, useParams } from "react-router-dom"
import { useQuestionnaireContext } from "../../pages/detail/contextProvider"
import { BreadCrumLabels, RootPath } from "../../../../components/breadCrumb/enum"
import { reincidenceDefault, reportSignatureDefault } from "./contants"

const OptionActionsBody = ({ children, defaultData, save, display, active, refBody, aaveragePoints, permission }: OptionActionsBodyProps) => {
    const { t } = useTranslation()
    const { setModal, closeModal } = useQuestionnaireContext()
    const { id } = useParams()
    const navigate = useNavigate()
    const refs = useRefs<DynamicRefRef>()
    const evidence = useEvidencesType({})
    const comment = useEvidencesType({})
    const commentRef = createRef<DynamicRefRef>()
    const [errors, setErrors] = useState({
        actionPlan: 0,
        reportFolio: 0
    })
    const [totalPoint, setTotalPoints] = useState(aaveragePoints)
    const [defaultChecks, setDefaultChecks] = useState({
        actionPlan: Boolean(defaultData?.actionPlan),
        evidences: Boolean(defaultData?.evidenceData),
        reportFolio: Boolean(defaultData?.reportFolio),
        comment: Boolean(defaultData?.comment),
        reincidence: Boolean(defaultData?.reincidence),
        permitting: Boolean(defaultData?.comment),
        reportSignature: Boolean(defaultData?.reportSignature)
    })

    const actions: Record<string, DinamicFormRefModel> = {
        ...display?.actionPlan && {
            actionPlan: {
                id: 'actionPlan',
                label: 'Plan de acción',
                name: 'actionPlan',
                type: 'switch',
                wrapper: (payload) => (
                    <Grid
                        item
                        xs={12}
                        children={(
                            <>
                                <ClickedBox
                                    children={payload.children}
                                    active={!!defaultChecks?.actionPlan}
                                    click={(e) => {
                                        e.stopPropagation()
                                        if (!!payload.childrenData?.data?.actionPlan && !!defaultChecks?.actionPlan) {
                                            openActionPlan()
                                        }
                                    }}
                                />
                                <ErrorMessage sx={{ height: 'fit-content' }} error={Boolean(errors.actionPlan)} message="Se encontraron  campos sin completar" />
                            </>
                        )}
                        key={payload.id}
                    />
                )
            },
        },
        ...display?.reportFolio && {
            reportFolio: {
                id: 'reportFolio',
                label: 'Folio',
                name: 'reportFolio',
                type: 'switch',
                wrapper: (payload) => (
                    <Grid
                        item
                        xs={12}
                        children={(
                            <>
                                <ClickedBox
                                    children={payload.children}
                                    active={!!defaultChecks?.reportFolio}
                                    click={(e) => {
                                        e.stopPropagation()
                                        if (!!defaultChecks?.reportFolio) {
                                            openReportFolio()
                                        }
                                    }}
                                />

                                <ErrorMessage sx={{ height: 'fit-content' }} error={Boolean(errors.reportFolio)} message="Se encontraron  campos sin completar" />
                            </>
                        )}
                        key={payload.id}
                    />
                )
            },
        },
        ...display?.evidence && {
            evidences: {
                id: 'evidences',
                label: 'Evidencias',
                name: 'evidences',
                type: 'switch',
                wrapper: (payload) => (
                    <Grid
                        item
                        xs={12}
                        children={(
                            <ClickedBox
                                children={payload.children}
                                active={!!defaultChecks?.evidences}
                                click={(e) => {
                                    e.stopPropagation()
                                    if (!!defaultChecks?.evidences) {
                                        openEvidence(e)
                                    }
                                }}
                            />
                        )}
                        key={payload.id}
                    />
                )
            },
        },
        ...display?.comments && {
            comment: {
                id: 'comment',
                label: 'Comentario de cierre',
                name: 'comment',
                type: 'switch',
                wrapper: (payload) => (
                    <Grid
                        item
                        xs={12}
                        children={(
                            <ClickedBox
                                children={payload.children}
                                active={!!defaultChecks?.comment}
                                click={(e) => {
                                    e.stopPropagation()
                                    if (!!defaultChecks?.comment) {
                                        openComent(e)
                                    }
                                }}
                            />
                        )}
                        key={payload.id}
                    />
                )
            },
        },
        ...display?.reportSignature && {
            reportSignature: {
                id: 'reportSignature',
                label: 'Reporte con firma',
                name: 'reportSignature',
                type: 'switch',
                wrapper: (payload) => (
                    <Grid
                        item
                        xs={12}
                        children={(
                            <ClickedBox
                                children={payload.children}
                                active={!!defaultChecks?.reportSignature}
                                click={(e) => {
                                    e.stopPropagation()
                                    if (!!defaultChecks?.reportSignature) {
                                        openSignature()
                                    }
                                }}
                            />
                        )}
                        key={payload.id}
                    />
                )
            },
        },
        ...display?.reincidence && {
            reincidence: {
                id: 'reincidence',
                label: 'Reincidencia',
                name: 'reincidence',
                type: 'switch',
                wrapper: (payload) => (
                    <Grid
                        item
                        xs={12}
                        children={(
                            <ClickedBox
                                children={payload.children}
                                active={!!defaultChecks?.reincidence}
                                click={(e) => {
                                    e.stopPropagation()
                                    if (!!defaultChecks?.reincidence) {
                                        openReincidence()
                                    }
                                }}
                            />
                        )}
                        key={payload.id}
                    />
                )
            },
        },
        ...display?.permitting && {
            permittings: {
                id: 'permitting',
                label: 'Permisología',
                name: 'permitting',
                type: 'switch',
                wrapper: (payload) => (
                    <Grid
                        item
                        xs={12}
                        children={(
                            <ClickedBox
                                children={<Typography>Permisología</Typography>}
                                active={true}
                                click={(e) => {
                                    e.stopPropagation()
                                    // if (!!defaultChecks?.permitting) {
                                    // if(permission) {
                                    //     permission()
                                    // }
                                    openPermittingTab()
                                    // }
                                }}
                            />
                        )}
                        key={payload.id}
                    />
                )
            },
        },
    }
    const [actionPlan, setActionPlan] = useState<ActionPlanState>({ title: 'quest name', open: false, defaultValues: defaultData?.actionPlan })
    const [evidenceData, setevdienceData] = useState<EvidenceData[]>(defaultData?.evidenceData || [])
    const [commentEvidenceData, setCommentEvdienceData] = useState<EvidenceData[]>(defaultData?.evidenceData || [])
    const [reincidence, setReincidence] = useState<ReincidenceState>({ data: defaultData?.reincidence ?? reincidenceDefault })
    const [signature, setSignature] = useState<SignatureState>({ data: defaultData?.reportSignature ?? reportSignatureDefault })
    const [defaultComment, setDefaultcomment] = useState<DynamicFormRefValues>()
    const [reportFolio, setReportFolio] = useState<DefaultReportFolio>()
    const openActionPlan = () => {
        setActionPlan(prev => ({ ...prev, open: true }))
    }
    const openReincidence = () => {
        setReincidence(prev => ({ ...prev, open: true, }))
    }
    const closeReincidence: CloseReincidence = ({ data }) => {
        setReincidence(prev => ({ ...prev, open: false, data }))
    }
    const openSignature = () => {
        setSignature(prev => ({ ...prev, open: true, }))
    }
    const closeSignature = () => {
        setSignature(prev => ({ ...prev, open: false }))
    }
    const saveSignature: CloseSignature = ({ data }) => {
        setSignature(prev => ({ ...prev, open: false, data: data }))
    }
    const saveReincidence: CloseReincidence = ({ data }) => {
        setReincidence(prev => ({ ...prev, open: false, data }))
    }
    useImperativeHandle(refBody, () => ({
        handleActivatingOption: ({ name, value }) => {
            setDefaultChecks(prev => ({ ...prev, [name]: Boolean(value) }))
            const sectValues = refs.refsByKey['options']?.setValues
            if (sectValues) {
                sectValues({ name, value })
            }
        },
        getData: () => {
            const data = getDataAndErrors({ external: true })
            return data
        },
        fillData: (defaultData) => {
            setActionPlan(prev => ({ ...prev, defaultValues: defaultData?.defaultData?.actionPlan }))
            setDefaultChecks(prev => ({ ...prev, actionPlan: Boolean(defaultData?.defaultData?.actionPlan) }))
            setReportFolio(prev => ({ ...prev ?? {}, ...defaultData?.defaultData?.reportFolio ?? {}, id: null }))
            setDefaultChecks(prev => ({ ...prev, reportFolio: Boolean(defaultData?.defaultData?.reportFolio) }))
            setevdienceData(defaultData?.defaultData?.evidenceData || [])
            setDefaultChecks(prev => ({ ...prev, evidences: !!defaultData?.defaultData?.evidenceData?.length }))
            setCommentEvdienceData(defaultData?.defaultData?.comment?.evidence || [])
            setDefaultcomment(defaultData?.defaultData?.comment?.default)
            setDefaultChecks(prev => ({ ...prev, comment: Boolean(defaultData?.defaultData?.comment?.evidence?.length || defaultData?.defaultData?.comment?.default) }))
        }
    }))
    const onChange = (payload?: DynamicFormRefValues) => {
        const name = payload?.current as string
        const value = payload?.[name]
        if (!value) {
            setErrors(prev => ({ ...prev, [name]: undefined }))
            if (name == 'actionPlan') { setActionPlan(prev => ({ ...prev, defaultValues: undefined })) }
            if (name == 'reportFolio') { setReportFolio(undefined) }
            if (name == 'comment') {
                setDefaultcomment(undefined)
                setCommentEvdienceData([])
            }
            if (name == 'reportSignature') {
                setSignature({data:undefined,open:false})
            }
        }
        setDefaultChecks(prev => ({ ...prev, [name]: Boolean(value) }))

        if (!!active) {
            active({ name, value: Boolean(value) })
        }
    }
    const closeActionPlan = () => {
        setActionPlan(prev => ({ ...prev, open: false }))
    }

    const saveActionPlan: ArrowBackActionPlan = (payload) => {
        let description = {
            title: payload.data.title,
            description: payload.data.description
        }

        delete payload?.data.title
        delete payload?.data.description
        delete payload?.dataFolios?.maxFolios

        const newData = {
            evidence: payload.evidence,
            // evidenceFolioManagement: payload.evidenceFolioManagement,
            data: payload?.data,
            description,
            dataFolios: payload.dataFolios,
            evidenceFolio: payload?.evidenceDataFolios,
            activeFolios: !!payload?.dataFolios,
            options: payload.options
        }
        const response = getActionPlans({ t, data: newData })
        setErrors(prev => ({
            ...prev,
            reportFolio: errors.reportFolio,
            actionPlan: defaultChecks.actionPlan ? response.errors.count : undefined,
        }))

        setActionPlan(prev => ({ ...prev, defaultValues: newData }))
        closeActionPlan()
    }

    const openPermittingTab = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            icon: 'warning',
            title: t('general.atention'),
            description: t('general.lostConfig'),
            confirmText: t('general.accept'),
            confirm: () => {
                closeModal()
                navigate(`/dashboard/questionnarie/permission/${id}?root=${RootPath.QUESTIONNAIRE_EDIT}-${BreadCrumLabels.Edit_Questionnaire}-${id}`)
            },
            cancel: closeModal
        }))
    }
    const openEvidence = (_: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
        evidence.clickOption({ item: {} })
    }
    const openComent = (_: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
        comment.clickOption({ item: {} })
    }

    const saveEvidence = (payload: EvidenceData[]) => {
        setevdienceData(payload)
        evidence.saveEvidence([], (count) => { })
    }
    const savecommentEvidence = (payload: EvidenceData[]) => {
        setCommentEvdienceData(payload)
        if (commentRef.current?.getValues) {
            const getValues = commentRef.current?.getValues
            setDefaultcomment(getValues())
            comment.saveEvidence([], (count) => { })
        }
    }

    const getDataAndErrors = (payload?: { external: boolean }) => {
        const response = getActionPlans({ t, data: actionPlan.defaultValues })
        let errorCount = 0
        setErrors(prev => ({
            ...prev,
            reportFolio: errors.reportFolio,
            actionPlan: defaultChecks.actionPlan ? response.errors.count : undefined,
        }))
        if (defaultChecks.actionPlan) { errorCount = Number(response.errors?.count ?? 0) }

        if (defaultChecks.reportFolio) { errorCount += Number(errors.reportFolio ?? 0) }
        if (!errorCount) {
            const existComment = (defaultChecks?.comment && (!!commentEvidenceData?.length || !!defaultComment))
            const existSignatures =  signature.data?.every(item => item.description?.trim().length > 0);
            if(!payload?.external) {
                setDefaultChecks(prev => ({ ...prev, comment: existComment }))
            }
            return {
                errorCount,
                data: {
                    actionPlan: defaultChecks?.actionPlan ? actionPlan.defaultValues : undefined,
                    evidenceData: defaultChecks?.evidences && !!evidenceData?.length ? evidenceData : undefined,
                    reportFolio: defaultChecks?.reportFolio ? reportFolio : undefined,
                    comment: existComment ? {
                        evidence: commentEvidenceData,
                        default: defaultComment
                    } : undefined,
                    reincidence: defaultChecks?.reincidence ? reincidence?.data : undefined,
                    reportSignature: (defaultChecks?.reportSignature && signature.data?.length && existSignatures) ? signature?.data : undefined
                }
            }
        } else {
            return {
                errorCount,
                data: {}
            }
        }
    }
    const saveData = () => {
        const { errorCount, data } = getDataAndErrors()
        if (!errorCount) {
            setActionPlan(prev => ({ ...prev, defaultValues: undefined }))
            setevdienceData([])
            save(data)
        }
    }

    const returnQuestonnaire = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('general.stayChanges'),
            description: '',
            confirm: () => {
                saveData()
                closeModal()
            },
            cancel: () => {
                setActionPlan(prev => ({ ...prev, defaultValues: undefined }))
                setevdienceData([])
                save({
                    actionPlan: defaultData?.actionPlan,
                    evidenceData: defaultData?.evidenceData,
                    reportFolio: defaultData?.reportFolio,
                    comment: defaultData?.comment,
                    reincidence: defaultData?.reincidence,
                    reportSignature: defaultData?.reportSignature
                })
                closeModal()
            }
        }))
    }

    const openReportFolio = () => {
        setReportFolio(prev => ({ ...prev, id: 'open' }))
    }
    const getReportFolioByAnswer = ({ body, evidence }: ArrowBackPayload) => {
        const report = body
        const { count } = validateReportFolio(report)

        setErrors(prev => ({ ...prev, reportFolio: count }))
        setReportFolio({
            id: null,
            default: report,
            evidence
        })
    }
    const closeReportFolioByAnswer = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('general.goBackToConfig'),
            description: t('general.changeWillBeDiscarded'),
            confirm: () => {
                setReportFolio(prev => ({ ...prev ?? {}, id: null }))
                closeModal()
            },
            cancel: closeModal
        }))
    }
    useEffect(() => {
        setActionPlan(prev => ({ ...prev, defaultValues: defaultData?.actionPlan }))
        setDefaultChecks(prev => ({ ...prev, actionPlan: Boolean(defaultData?.actionPlan) }))
    }, [defaultData?.actionPlan])

    useEffect(() => {
        setReportFolio(prev => ({ ...prev ?? {}, ...defaultData?.reportFolio ?? {}, id: null }))
        setDefaultChecks(prev => ({ ...prev, reportFolio: Boolean(defaultData?.reportFolio) }))
    }, [defaultData?.reportFolio])

    useEffect(() => {
        setTotalPoints(aaveragePoints)
    }, [aaveragePoints])
    useEffect(() => {
        setevdienceData(defaultData?.evidenceData || [])
        setDefaultChecks(prev => ({ ...prev, evidences: !!defaultData?.evidenceData?.length }))
    }, [defaultData?.evidenceData])
    useEffect(() => {
        setReincidence({ data: defaultData?.reincidence ?? reincidenceDefault })
        setDefaultChecks(prev => ({ ...prev, reincidence: !!defaultData?.reincidence }))
    }, [defaultData?.reincidence])
    useEffect(() => {
        setCommentEvdienceData(defaultData?.comment?.evidence || [])
        setDefaultcomment(defaultData?.comment?.default)
        setDefaultChecks(prev => ({ ...prev, comment: Boolean(!!defaultData?.comment?.evidence?.length || !!defaultData?.comment?.default) }))
    }, [defaultData?.comment?.evidence, defaultData?.comment?.default])
    return children({ saveSignature,closeSignature, signature, actions, returnQuestonnaire, actionPlan, reincidence, closeActionPlan, saveReincidence, closeReincidence, evidence, evidenceData, defaultChecks, errors, reportFolio, totalPoint, comment, commentRef, defaultComment: defaultComment, commentEvidenceData, savecommentEvidence, addRef: refs.addRef, closeReportFolioByAnswer, getReportFolioByAnswer, onChange, saveData, saveActionPlan, saveEvidence })
}

export { OptionActionsBody }